import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useAppDispatch } from '../../../../../App/Hooks/reduxHooks'
import { createBlockCategory } from '../../../../../App/store/features/blockCategory/apiActions/createBlockCategory'
import { getBlockCategory } from '../../../../../App/store/features/blockCategory/apiActions/getBlockCategory'
import { TextInput } from '../../../../../Common/TextInput'
import { isInstanceOfIThunkError } from '../../../../utils/interfaceCheck'
import { InputWrapper } from '../InputWrapper'

import { CategoryAddButton, CategoryCancelButton } from './style'

interface IProps {
  setIsInputFieldOpen: (isInputFieldOpen: boolean) => void
}

export const AddBlockCategory = ({ setIsInputFieldOpen }: IProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [temporaryCategory, setTemporaryCategory] = useState<string>()

  const addBlockCategory = () => {
    if (temporaryCategory) {
      setIsInputFieldOpen(false)
      dispatch(createBlockCategory({ name: temporaryCategory })).then(
        ({ payload }) => {
          if (
            typeof payload !== 'undefined' &&
            !isInstanceOfIThunkError(payload)
          ) {
            dispatch(getBlockCategory({ categoryUuid: payload.uuid }))
            return null
          }
          return null
        },
      )
    }
  }
  return (
    <InputWrapper>
      <TextInput
        // leadingIcon="pen"
        // fieldLabel={t('Blocked category')}
        // fieldColor="#005cd9"
        onChange={e => setTemporaryCategory(e.target.value)}
        // customWidth="400px"
      />
      <CategoryCancelButton onClick={() => setIsInputFieldOpen(false)}>
        {t('Cancel')}
      </CategoryCancelButton>
      <CategoryAddButton onClick={addBlockCategory}>
        {t('Add')}
      </CategoryAddButton>
    </InputWrapper>
  )
}
